import {hydrate as hydrateUi} from '../core/redux/ui'
import hydrateTicket from '../ticket/hydrate'

export default function() {
	return {
		...hydrateUi(),
		...hydrateTicket()
	}
}


// WEBPACK FOOTER //
// ./lib/app/hydrate.js